import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api/axiosInstance";

const CourseForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "",
    description: "",
    category: "Technical",
    level: "Beginner",
    durationWeeks: 0,
    priceUSD: 0,
    imageUrl: "",
    isFeatured: false,
  });

  useEffect(() => {
    if (id) {
      api.get(`/api/courses/${id}`).then((res) => {
        setForm(res.data.data);
      });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.title) {
      alert("Title is required");
      return;
    }

    if (id) {
      await api.put(`/api/courses/${id}`, form);
    } else {
      await api.post("/api/courses/course", form);
    }

    navigate("/admin/courses");
  };

  return (
    <form className="max-w-xl space-y-4" onSubmit={handleSubmit}>
      <h2 className="text-xl font-bold">
        {id ? "Edit Course" : "Create Course"}
      </h2>

      <input
        className="w-full border p-2 rounded"
        placeholder="Title"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
      />

      <textarea
        className="w-full border p-2 rounded"
        placeholder="Description"
        value={form.description}
        onChange={(e) => setForm({ ...form, description: e.target.value })}
      />

      <select
        className="w-full border p-2 rounded"
        value={form.category}
        onChange={(e) => setForm({ ...form, category: e.target.value })}
      >
        <option value="Technical">Technical</option>
        <option value="Behavioral">Behavioral</option>
        <option value="Product">Product</option>
        <option value="Leadership">Leadership</option>
        <option value="Data Science">Data Science</option>
        <option value="Consulting">Consulting</option>
      </select>

      <select
        className="w-full border p-2 rounded"
        value={form.level}
        onChange={(e) => setForm({ ...form, level: e.target.value })}
      >
        <option value="Beginner">Beginner</option>
        <option value="Intermediate">Intermediate</option>
        <option value="Advanced">Advanced</option>
      </select>

      <input
        type="number"
        className="w-full border p-2 rounded"
        placeholder="Duration (weeks)"
        value={form.durationWeeks}
        onChange={(e) => setForm({ ...form, durationWeeks: Number(e.target.value) })}
      />

      <input
        type="number"
        className="w-full border p-2 rounded"
        placeholder="Price (USD)"
        value={form.priceUSD}
        onChange={(e) => setForm({ ...form, priceUSD: Number(e.target.value) })}
      />

      <input
        className="w-full border p-2 rounded"
        placeholder="Image URL"
        value={form.imageUrl}
        onChange={(e) => setForm({ ...form, imageUrl: e.target.value })}
      />

      <label className="flex gap-2">
        <input
          type="checkbox"
          checked={form.isFeatured}
          onChange={(e) =>
            setForm({ ...form, isFeatured: e.target.checked })
          }
        />
        Featured
      </label>

      <button className="bg-primary text-white px-6 py-2 rounded">
        Save
      </button>
    </form>
  );
};

export default CourseForm;
